import { DomainError } from "@econ-v1/domain";
export class LiveQueryRegistry {
    #definitions = new Map();
    get(name) {
        const definition = this.#definitions.get(name);
        if (definition === undefined) {
            throw new DomainError({ code: "unsupported_query", message: `A live query named "${name}" is not registered` });
        }
        return definition;
    }
    /**
     * Whether the named query reads the durable, OPFS-backed local SQLite cache.
     *
     * An unregistered name answers `true`: the caller's storage gate then applies, and the
     * engine raises its own "not registered" error afterwards. Answering `false` for an
     * unknown name would let a query slip past the gate on a typo.
     */
    requiresDurableStorage(name) {
        return this.#definitions.get(name)?.requiresDurableStorage ?? true;
    }
    register(definition) {
        if (this.#definitions.has(definition.name)) {
            throw new Error(`A live query named ${definition.name} is already registered`);
        }
        this.#definitions.set(definition.name, definition);
    }
}
//# sourceMappingURL=registry.js.map